import React from "react";
import DropDown from "../../../../../common/components/shared/dropDown/dropDown";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";
import {CompanyService} from "../../../../../dictionaries/services/companyService";
import i18n from "../../../../../i18n/i18n";
import {IOrderStore} from "../../../../stores/orderStore";
import {DropDownUtils} from "../../../../../helpers/dropDownUtils";
import {observer} from "mobx-react";
import {CompanyModelForList} from "../../../../../dictionaries/models/company";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import {Api} from "../../../../../helpers/api";

interface TransportationSectionState {
    companies: CompanyModelForList[];
    companiesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class TransportationSection extends React.Component <any, TransportationSectionState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            companies: [],
            companiesResponse: undefined
        };
    }

    async componentDidMount() {
        await this.getCompanies();
    }

    render() {
        const orderStore = this.context.orderStore as IOrderStore;

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.order.details.transportation.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        {orderStore.displayTrailerRegNo && (
                            <TextInput
                                label={i18n.t("transportation.order.details.transportation.properties.trailerRegNo")}
                                validatedValue={orderStore.trailerRegNo}
                                testId="trailer-reg-no"
                                offAutocomplete
                            />
                        )}
                        <DropDown
                            className="element"
                            label={i18n.t("transportation.order.details.transportation.properties.transportCompany")}
                            items={this.transportCompanyToDropdown()}
                            validatedValue={orderStore.transportCompanyId}
                            testId="transport-company"
                            onChange={(companyId) => {
                                orderStore.setPaymentMethodForCompany(companyId);
                            }}
                            error={!Api.isSuccess(this.state.companiesResponse) ? i18n.t("errorMessages.companiesErrorSuffix") : ""}
                            reloadFunc={() => this.getCompanies()}
                        />
                        {orderStore.displayRecipient && (
                            <TextInput
                                label={i18n.t("transportation.order.details.transportation.properties.recipient")}
                                validatedValue={orderStore.recipient}
                                testId="recipient"
                                offAutocomplete
                            />
                        )}
                        {orderStore.displayLorryRegNo && (
                            <TextInput
                                label={i18n.t("transportation.order.details.transportation.properties.lorryRegNo")}
                                validatedValue={orderStore.lorryRegNo}
                                testId="lorry-reg-no"
                                offAutocomplete
                            />
                        )}
                        {orderStore.displaySupplierLorryRegNo && (
                            <TextInput
                                label={i18n.t("transportation.order.details.transportation.properties.supplierLorryRegNo")}
                                validatedValue={orderStore.supplierLorryRegNo}
                                testId="supplier-reg-no"
                                offAutocomplete
                            />
                        )}
                        {orderStore.displayRecipientLorryRegNo && (
                            <TextInput
                                label={i18n.t("transportation.order.details.transportation.properties.recipientLorryRegNo")}
                                validatedValue={orderStore.recipientLorryRegNo}
                                testId="recipient-reg-no"
                                offAutocomplete
                            />
                        )}
                    </Row>
                </div>
            </div>
        );
    }

    private transportCompanyToDropdown() {
        const orderStore = this.context.orderStore as IOrderStore;

        return DropDownUtils.listToDropDownMap(orderStore.companies);
    }

    private async getCompanies() {
        const orderStore = this.context.orderStore as IOrderStore;
        const companiesResponse = await CompanyService.getAll();

        this.setState({
            companies: (companiesResponse)?.data?.data || [],
            companiesResponse
        });

        orderStore.setCompanies(this.state.companies);
    }
}

export default observer(TransportationSection);